import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=3828a2e4&scoped=true"
import script from "./member-list.vue?vue&type=script&lang=js"
export * from "./member-list.vue?vue&type=script&lang=js"
import style0 from "./member-list.vue?vue&type=style&index=0&id=3828a2e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3828a2e4",
  null
  
)

export default component.exports